import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{--spectrum-drop-zone-border-color:var(--system-drop-zone-border-color)}
`;
export default styles;